import type { ProductTemplateDownload } from '@/lib/product-template-downloads';
import { normalizeProductionSheetProfile } from '@/lib/editor/production-sheet-profile';
import registry from './official-workfiles.json';

export function verifiedWorkfileProfile(product: string | undefined, configuration: Record<string, unknown>) {
  const matches = registry.filter(row => [row.sku, row.slug].includes(String(product))
    && Object.entries(row.match).every(([key, value]) => String(configuration[key]) === value));
  if (matches.length > 1) throw new Error('Ambiguous official template configuration');
  return matches.length ? normalizeProductionSheetProfile(matches[0].productionSheetProfile) : null;
}

export function verifiedWorkfileDownloads(product: string | undefined, locale = 'nl'): ProductTemplateDownload[] | undefined {
  const rows = registry.filter(row => [row.sku, row.slug].includes(String(product)));
  if (!rows.length) return undefined;
  return rows.map(row => {
    const originals = row.originals as Record<string, {url: string; fileName: string}>;
    const file = originals[locale] || originals.nl || Object.values(originals)[0];
    return { id: row.variant, label: row.variant[0].toUpperCase() + row.variant.slice(1), ...file };
  });
}
